
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 6.25a2.917 2.917 0 11-5.834 0 2.917 2.917 0 015.833 0z","stroke":"#fff","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M11.25 9.167a2.917 2.917 0 000-5.834","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M10.952 16.667H3.214c-.855 0-1.548-.64-1.548-1.429 0-1.972 1.732-3.571 3.87-3.571H8.63c.871 0 1.675.265 2.322.714","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.834 11.667v5m2.5-2.5h-5","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    